<template>
  <div>

    <v-card flat class="d-flex flex-column" color="transparent" style="gap: 10px; height: calc(100vh - 74px)">

      <v-card flat class="d-flex flex-grow-1" color="transparent" style="gap: 10px">
        <v-card flat class="d-flex flex-column flex-shrink-0" color="transparent" style="height: 100%; width: 250px; gap: 20px">

          <CardCampo label="Referência">
            <v-text-field
              v-model="referencia"
              dense
              flat
              solo
              hide-details
              single-line
              append-icon_="mdi-magnify"
              ref="referencia"
              label="Referência"
              autofocus
              :loading="buscando"
              @keyup.f2="buscarProduto"
              @keyup.enter.stop="buscarReferencia"
              @keyup.esc="onKeyUpEscAdicionarProduto"
              @click:append="buscarProduto"
              style="font-size: 34px;"
            ></v-text-field>
          </CardCampo>
          <CardCampo label="Quantidade">
            <z-campo-valor
              v-model="produto.quantidade"
              flat
              solo
              hide-details
              single-line
              ref="quantidade"
              label="Quatidade"
              :decimais="config.CASAS_DECIMAIS_QUANTIDADE"
              :readonly="buscando || !produto.descricao"
              @keyup.enter="enterQuantidade"
              @keyup.esc="onKeyUpEscAdicionarProduto"
              @input="calcularSubTotal"
              style="font-size: 34px;"
            >
              <template #append_>
                <v-btn 
                  class="ml-3" 
                  color="primary"
                  small 
                  depressed
                  :disabled="produto.descricao == ''"
                  @click="adicionarItem"
                >
                  Enter
                </v-btn>
              </template>
            </z-campo-valor>
          </CardCampo>
          <CardCampo label="Valor">
            <z-campo-valor
              v-model="produto.valor"
              flat
              solo
              hide-details
              single-line
              ref="valor"
              label="Valor"
              :decimais="2"
              readonly
              @keyup.enter="adicionarItem"
              @keyup.esc="onKeyUpEscAdicionarProduto"
              @input="calcularSubTotal"
              style="font-size: 34px;"
            >
              <template #append_>
                <v-btn 
                  class="ml-3" 
                  color="primary"
                  small 
                  depressed
                  :disabled="produto.descricao == ''"
                  @click="adicionarItem"
                >
                  Enter
                </v-btn>
              </template>
            </z-campo-valor>
          </CardCampo>
          <CardCampo label="SubTotal">
            <z-campo-valor
              v-model="produto.subtotal"
              flat
              solo
              hide-details
              single-line
              ref="subtotal"
              label="SubTotal"
              :decimais="2"
              readonly
              style="font-size: 34px;"
            ></z-campo-valor>
          </CardCampo>
        </v-card>
  
        <v-card flat color="transparent" class="d-flex flex-column flex-grow-1" style="height: 100%; gap: 10px">
          <v-card color="primary" class="flex-shrink-0" style="height: 100px" dark>
            <v-card-text class="px-3 py-1" style="height: 100px">
                  <div class="text-caption mb-2">Produto</div>
                  <h4 class="text-h4 white--text mb-1" style="line-height: 2rem">
                    {{ produto.descricao }} 
                  </h4>

                  <h3 v-if="pedido.produtos.length == 0 && !produto.descricao" class="text-h3 white--text text-center">
                    CAIXA LIVRE
                  </h3>

                  <div class="d-flex" style="gap: 2px;" v-if="produto.grade">
                    <v-chip
                      v-for="(grade, index) in produto.grade"
                      small
                      color="white"
                      class="teal--text"
                      :key="index"
                      @click="$refs.dialogoSelecionarVariacao.abrir()"
                    >{{ grade.descricao }}</v-chip>
                  </div>
                </v-card-text>
          </v-card>
          
          <v-card color="yellow_" class="flex-grow-1" style="height: 200px">
            <v-card-text style="overflow-y: auto; height: 100%">
              <v-data-table
                disable-pagination
                disable-sort
                hide-default-footer
                :headers="headers"
                :items="pedido.produtos"
                :loading="carregando_itens"
                style="font-size: 2rem;"
              >
                <template v-slot:item="{ item, index }">
                  <tr class="text-body-1">
                    <td class="text-body-1">{{ index + 1 }}</td>
                    <td class="text-body-1">{{ item.referencia }}</td>
                    <td :class="{'text-h5': $vuetify.breakpoint.xlOnly}" class="text-body-1">
                      <div>{{ item.descricao }}</div>
                      <template v-if="item.grade">
                        <v-chip
                          v-for="(_grade, index) in item.grade"
                          class="mr-2"
                          x-small 
                          color="grey lighten-2"
                          :key="index"
                        >{{_grade.descricao}}</v-chip>
                      </template>
                    </td>
                    <td class="text-right text-body-1 text-no-wrap">
                      {{ item.quantidade | valorQTD(config.CASAS_DECIMAIS_QUANTIDADE) }} {{ item.unidade }} 
                    </td>
                    <td class="text-right text-body-1">
                      {{ item.valor | valorBR(2) }}
                    </td>
                    <td class="text-right text-body-1">
                      {{ item.subtotal | valorBR(2) }}
                    </td>

                    <td class="text-center text-no-wrap">
                      <v-icon @click="removerItem(item)" tabindex="-1">mdi-delete</v-icon>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <!-- <v-card color="red" class="flex-shrink-0" style="height: 80px">
            &nbsp;
          </v-card> -->

        </v-card>
      </v-card>

      <v-card class="flex-shrink-0" style="height: 90px;">
        <v-card-text class="d-flex align-center" style="height: 100%; gap: 10px">
          <v-slide-group
            multiple
            show-arrows
          >
            <v-slide-item>
              <v-btn dark color="teal" class="mr-2" depressed rounded @click="buscarProduto">F2 - Consultar Produtos</v-btn>
            </v-slide-item>
            <!-- <v-slide-item>
              <v-btn color="teal lighten-4" class="primary--text mr-2" depressed rounded @click="$emit('iniciarVenda')">F3 - Iniciar Venda</v-btn>
            </v-slide-item> -->
            <!-- <v-slide-item>
              <v-btn 
                color="blue lighten-4" 
                class="blue--text mr-2" 
                depressed 
                rounded
                :disabled="pdvStore.pedido.produtos.length == 0"
                @click="$emit('finalizarVenda')"
              >F5 - Finalizar Venda</v-btn>
            </v-slide-item> -->
            <v-slide-item>
              <v-btn color="teal lighten-4" class="teal--text mr-2" depressed rounded @click="exibirVendas">F9 - Vendas</v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-card-text>
      </v-card>
    </v-card>

    <dialogo-buscar-produto-grupos
      ref="buscaproduto"
      @selecionar:produto="selecionarProduto"
    ></dialogo-buscar-produto-grupos>

    <z-dialogo-sim-nao
      ref="dialogoRemoverItem"
      titulo="Remover Item?"
      botaoSim="Remover"
      botaoNao="Não Remover"
      corBotaoSim="error"
    >
      Este item será removido do pedido. Deseja remover?
    </z-dialogo-sim-nao>

    <selecionar-variacao 
      ref="dialogoSelecionarVariacao" 
      :produto="produto"
      @cancelar="onKeyUpEscAdicionarProduto"
      @selecionar:variacao="selecionarVariacao"
    ></selecionar-variacao>

    <z-notificacao ref="notificacao"></z-notificacao>
    <PdvVendas ref="vendas"></PdvVendas>
    
  </div>
</template>

<script>
import { mapWritableState, mapStores } from 'pinia';
import { mapMutations, mapActions, mapState } from "vuex";

import BuscaProduto from "@/pages/pedidos/BuscaProduto";
import DialogoBuscarProduto from "@/pages/pedidos/DialogoBuscarProduto";
import SelecionarVariacao from "@/pages/pedidos/SelecionarVariacao";
import DialogoExibirEntradas from "@/pages/produtos/DialogoExibirEntradas";
import DialogoBuscarProdutoGrupos from "@/components/buscas/DialogoBuscarProdutoGrupos";
import CardCampo from "./partes/CardCampo";
import PdvVendas from "./PdvVendas";

import produtosApi from "@/app/services/produtos";
import { trunc } from "@/app/helpers/utils";

import { usePDVStore } from '@/app/store/pinia/pdv';

export default {
  name: "PDVProdutos",
  
  components: {
    BuscaProduto,
    DialogoBuscarProduto,
    SelecionarVariacao,
    DialogoExibirEntradas,
    DialogoBuscarProdutoGrupos,
    CardCampo,
    PdvVendas
  },

  inject: ['$imprimir'],

  data() {
    return {
      buscando: false,
      terminando: false,
      headers: [
        { text: "Item", value: "", width: "80px", sortable: false, },
        { text: "Referência", value: "referencia", width: "100px", sortable: false, },
        { text: "Descrição", value: "descricao", sortable: false },
        { text: "Qtd.", value: "quantidade", align: "right", width: "120px", sortable: false, },
        { text: "Valor", value: "valor", align: "right", width: "120px", sortable: false },
        { text: "SubTotal", value: "subtotal", align: "right", width: "120px", sortable: false, },
        { text: "", value: "", width: "10px", align: "center", sortable: false, },
      ],
      itens: [],
      carregando_itens: false,
    };
  },

  computed: {
    ...mapWritableState(usePDVStore, ['pedido', 'produto', 'referencia']),
    ...mapStores(usePDVStore),

    config() {
      return this.$store.state.configuracoes;
    },
  },

  beforeDestroy() {
    // window.removeEventListener('keydown', this.eventosTeclas);
  },

  mounted() {
    // window.addEventListener('keydown', this.eventosTeclas);
    this.adicionaEventosTeclado();
    this.pdvStore.pdvProdutosEventsHandler.enable();
  },

  methods: {
    ...mapActions("produtos", ["buscarProdutoPorReferencia"]),

    adicionaEventosTeclado() {
      this.pdvStore.pdvProdutosEventsHandler.addKeyEvent("F2", (event) => {
        event.preventDefault();
        this.buscarProduto();
      });
      this.pdvStore.pdvProdutosEventsHandler.addKeyEvent("F5", (event) => {
        event.preventDefault();
        this.$emit('finalizarVenda');
      });
      this.pdvStore.pdvProdutosEventsHandler.addKeyEvent("F9", (event) => {
        event.preventDefault();
        this.exibirVendas();
      });
    },

    eventosTeclas(event) {
      if (event.code == 'F2') {
        event.preventDefault();
        this.buscarProduto();
        console.log('F2');
      }

      if (event.code == 'F3') {
        event.preventDefault();
        console.log('F3');
      }

      if (event.code == 'F5') {
        event.preventDefault();
        this.$emit('finalizarVenda');
        console.log('F5');
      }

      if (event.code == 'F7') {
        event.preventDefault();
        console.log('F7');
        this.$emit('selecionarVendedor')
      }

      if (event.code == 'F8') {
        event.preventDefault();
        console.log('F8');
        this.$emit('selecionarCliente')
      }

      if (event.code == 'F9') {
        event.preventDefault();
        console.log('F9');
        this.exibirVendas();
      }
    },

    exibirVendas() {
      this.$refs.vendas.abrir();
    },

    async buscarReferencia() {
      this.pdvStore.limparProduto();

      if (!this.referencia) {
        this.buscarProduto();
        return;
      }

      try {
        this.buscando = true;
        let produto = await this.buscarProdutoPorReferencia(this.referencia);
        if (produto) {
          this.selecionarProduto(produto);
        }
      } catch (error) {
        this.buscarProduto(this.referencia);
        console.log(error);
        // throw error;
      } finally {
        this.buscando = false;
      }
    },

    buscarProduto(referencia) {
      this.$refs.buscaproduto.abrir(referencia);
    },

    calcularSubTotal() {
      this.produto.subtotal = trunc(Number(this.produto.quantidade) * Number(this.produto.valor));
    },

    selecionarProduto(produto) {
      try {
        console.log(produto);
        this.referencia = produto.referencia;
        
        this.produto.produto_id = produto.id;
        this.produto.referencia = produto.referencia;
        this.produto.descricao = produto.descricao;
        this.produto.quantidade = 1;
        this.produto.unidade = produto.unidade;
        this.produto.estoque = produto.estoque;
        this.produto.valor = produto.valor_venda;
        this.produto.subtotal = trunc(Number(this.produto.quantidade) * Number(this.produto.valor));
        this.produto.variacoes = produto.variacoes;
  
        if (produto.variacoes.length > 0) {
          this.$refs.dialogoSelecionarVariacao.abrir();
          return;
        }
  
        this.setFocus("quantidade");
      } catch (error) {
        console.log(error);
        throw error;
      }
    },

    selecionarVariacao({ grade, quantidade }) {
      this.$set(this.produto, "grade", grade);
      this.produto.quantidade = quantidade;
      this.produto.subtotal = trunc(Number(this.produto.quantidade) * Number(this.produto.valor));
      this.setFocus("quantidade");
    },

    onKeyUpEscAdicionarProduto() {
      this.referencia = "";
      this.pdvStore.limparProduto();
      this.setFocus("referencia");
    },

    enterQuantidade() {
      
      // if (this.config.ALTERAR_PRECO_NO_PEDIDO) {
      //   this.$refs.valor.focus();
      //   return;
      // }

      this.adicionarItem();
    },

    validarItem() {
      if (this.produto.referencia == "") {
        return false;
      }

      if (this.produto.descricao == "") {
        return false;
      }

      if (this.produto.quantidade == 0) {
        return false;
      }

      if (!this.produto.produto_id) {
        return false;
      }

      return true;
    },

    async adicionarItem() {
      if (!this.validarItem()) {
        console.log("Dados inválidos.");
        
        this.$eventbus.erroSistema("Dados inválidos.");
        return;
      }

      console.log(this.produto);
      
      // this.produto.quantidade = this.produto.quantidade;
      this.produto.subtotal = trunc(Number(this.produto.quantidade) * Number(this.produto.valor));

      this.pedido.produtos.push(this.produto);
  

      // produto = await balancoApi.adicionarItem(produto);

      // // this.atualizarLista({...produto});
      // this.somarProduto({...produto});

      this.referencia = "";

      this.pdvStore.limparProduto();

      this.$refs.referencia.focus();
    },

    async atualizarItem(produto) {

      try {
        this.$set(produto, "loading", true);

        await balancoApi.adicionarItem({
          atualizar: true,
          balanco_id: this.balanco.id,
          produto_id: produto.produto_id,
          descricao: produto.descricao,
          estoque: produto.estoque,
          grade: produto.grade,
        });
        
      } catch (error) {
        this.$eventbus.erro("Não foi possível atualizar o item", error);
      } finally {
        this.$set(produto, "loading", false);
      }
    },

    atualizarLista(produto) {
      let item = this.itens.find((item) => item.produto_id == produto.produto_id);

      if (item) {
        item.estoque += this.busca.estoque;
      } else {
        produto.estoque = this.busca.estoque;
        this.itens.unshift(produto);
      }
    },

    somarProduto(produto) {
      const { index, produto: produto_encontrado } = this.encontrarProdutoNoPedido(produto, this.itens);

      if (index > -1) {
        // const produto_encontrado = this.produtos[index];
        // produto_encontrado.status = produto_encontrado.status != this.$globals.STATUS_PRODUTO.NEW ? this.$globals.STATUS_PRODUTO.CHANGED : produto_encontrado.status;
        produto_encontrado.estoque += Number(this.busca.estoque)
        // produto_encontrado.subtotal = trunc(Number(produto_encontrado.quantidade) * Number(produto_encontrado.valor));
        this.itens.splice(index, 1, produto_encontrado);
      } else {
        this.itens.unshift(produto);
      }
    },

    encontrarProdutoNoPedido(produto, produtos) {
      let index = -1;

      if (!produto.grade) {
        index = produtos.findIndex(_produto => _produto.produto_id == produto.produto_id);
      } else {
        index = this.parseProdutos(produtos).findIndex(_produto => {
          return _produto.grade_descricao == this.parseGradeProduto(produto).grade_descricao;
        });
      }

      return {
        index,
        produto: produtos[index]
      };
    },

    parseProdutos(produtos) {
      let result = [];

      produtos.forEach(item => {
          if ((!!item.grade && item.grade.length === 0) || !item.grade) {
              result.push({
                  id: item.produto_id,
                  referencia: item.referencia,
                  descricao_produto: item.descricao,
                  grade_descricao: null
              });
          } else {
              let grade = '';
              item.grade.forEach(gradeItem => {
                grade += gradeItem.descricao;
              });
              
              result.push({
                  id: item.produto_id,
                  referencia: item.referencia,
                  descricao_produto: item.descricao,
                  grade_descricao: grade
              });
          }
      });

      return result;
    },

    parseGradeProduto(produto) {
      let grade = '';
      produto.grade.forEach(gradeItem => {
        grade += gradeItem.descricao;
      });
      
      return {
          id: produto.produto_id,
          referencia: produto.referencia,
          descricao_produto: produto.descricao,
          grade_descricao: grade
      }
    },

    async removerItem(produto) {
      const response = await this.$refs.dialogoRemoverItem.abrir();

      if (response == true) {
        this.$refs.dialogoRemoverItem.startLoading();
        // await balancoApi.removerItem(produto);

        let index = this.pedido.produtos.findIndex(
          (item) => item.produto_id == produto.produto_id
        );
        this.pedido.produtos.splice(index, 1);

        this.$refs.dialogoRemoverItem.fechar();
        this.setFocus("referencia");
      }
    },

    imprimir() {
      this.$imprimir(`balanco/${this.balanco.id}/imprimir`);
    },

    limparProduto() {
      this.produto = {
        produto_id: null,
        referencia: '',
        descricao: '',
        quantidade: 0,
        unidade: null,
        valor: 0,
        subtotal: 0,
        estoque: 0,
        grade: [],
        variacoes: [],
        status: null,
      };
    },


  },

  watch: {
    'pedido.produtos'(value) {
      this.pdvStore.calcularTotais();
    },
  },

};
</script>

<style lang="scss" scoped>
.pdv-sticky {
  position: sticky;
  top: 48px;
  z-index: 100;
}


.wrapper {
  display: flex;
  flex-direction: column;
  // height: 100vh; /* Wrapper ocupa toda a altura da tela */
  gap: 15px;
}

.item_superior {
  height: 200px; /* Altura fixa */
  flex-shrink: 0; /* Evita que seja reduzido */
  background-color: white; /* Apenas para visualização */
}

.item_inferior {
  flex_: 1; /* Ocupa o restante do espaço disponível */
  display: flex; /* Necessário para layout interno */
  height: calc(100vh - 48px - 12px - 15px - 220px); /* Calcula a altura restante */
}

.item_filho {
  flex: 1; /* Ocupa todo o espaço restante dentro do item_inferior */
  overflow-y: auto; /* Scroll vertical no conteúdo excedente */
  height: 100%; /* Garante que o item_filho ocupe a altura completa do item_inferior */
  background-color: lightgray; /* Apenas para visualização */
}

  .auto_scroll_y {
    overflow-y: auto;
  }
</style>
